module.exports = __webpack_public_path__ + "static/media/Max75stand_in.f42a2398.jpg";